import { assert } from '@ember/debug';

import ApplicationAdapter from './application';

export default class EntrySignInFieldAdapter extends ApplicationAdapter {
  urlForQuery(
    query: { entryId?: string; [key: string]: unknown },
    _modelName: Parameters<ApplicationAdapter['urlForQuery']>[1],
  ): string {
    assert('entry-sign-in-field adapter requires entryId in query', query.entryId);

    const entryId = query.entryId;
    delete query.entryId; // Remove from query params
    // Build URL: /a/visitors/api/v3/entries/:id/sign-in-fields
    return `/${this.namespace}/entries/${entryId}/sign-in-fields`;
  }
}
